<template>
    <div>
        <div class="sub-lnb-menu">
            <ul class="sub-lnb-menu__list">
                <li class="sub-lnb-menu__item" :class="{active: this.lnbIndex==1}" @click="lnbFn(1)">
                    <div class="line"></div>
                    <a href="javascript:;" @click.prevent="scrollTo('step1')">중환자실에서 제공되는 <br>
                        서비스 및 주의사항</a>
                </li>
                <li class="sub-lnb-menu__item" :class="{active: this.lnbIndex==2}" @click="lnbFn(2)">
                    <div class="line"></div>
                    <a href="javascript:;" @click.prevent="scrollTo('step2')">준비물품</a>
                </li>
                <li class="sub-lnb-menu__item" :class="{active: this.lnbIndex==3}" @click="lnbFn(3)">
                    <div class="line"></div>
                    <a href="javascript:;" @click.prevent="scrollTo('step3')">회진 안내</a>
                </li>
                <li class="sub-lnb-menu__item" :class="{active: this.lnbIndex==4}" @click="lnbFn(4)">
                    <div class="line"></div>
                    <a href="javascript:;" @click.prevent="scrollTo('step4')">식사 안내</a>
                </li>
                <li class="sub-lnb-menu__item" :class="{active: this.lnbIndex==5}" @click="lnbFn(5)">
                    <div class="line"></div>
                    <a href="javascript:;" @click.prevent="scrollTo('step5')">면회 안내 및 주의사항</a>
                </li>
                <li class="sub-lnb-menu__item" :class="{active: this.lnbIndex==6}" @click="lnbFn(6)">
                    <div class="line"></div>
                    <a href="javascript:;" @click.prevent="scrollTo('step6')">기타사항</a>
                </li>
                <li class="sub-lnb-menu__item" :class="{active: this.lnbIndex==7}" @click="lnbFn(7)">
                    <div class="line"></div>
                    <a href="javascript:;" @click.prevent="scrollTo('step7')">중환자실 입원 시 <br> 필요물품 리스트</a>
                </li>
            </ul>
        </div>

        <div class="subSwiper info" v-if="$store.getters.getHost == 'H0006'">
            <swiper :cssMode="true" :navigation="{
					nextEl: '.subSwiper-next',
					prevEl: '.subSwiper-prev'
				}" :pagination="{ clickable: true }" :mousewheel="true" :keyboard="true" :modules="modules">
                <swiper-slide>
                    <img src="/resource/img/info-img02.jpg" alt="">
                </swiper-slide>
                <swiper-slide>
                    <img src="/resource/img/info-img03.jpg" alt="">
                </swiper-slide>
                <swiper-slide>
                    <img src="/resource/img/info-img04.jpg" alt="">
                </swiper-slide>
            </swiper>
            <div class="subSwiper-bth subSwiper-next"></div>
            <div class="subSwiper-bth subSwiper-prev"></div>
        </div>

        <!-- 뇌혈관 -->
        <div class="subSwiper info" v-else>
            <swiper :cssMode="true" :pagination="{ clickable: true }" :mousewheel="true" :keyboard="true" :modules="modules">
                <swiper-slide>
                    <img src="/resource/img/intensive01-brain.jpg" alt="">
                </swiper-slide>
            </swiper>
        </div>

        <div id="step1" class="step-item info">
            <h3 class="bullet01">중환자실에서 제공되는 서비스 및 주의사항</h3>
            <p class="bullet04 num1 depth">흡인, 체위변경, 부분목욕, 배뇨, 배변관리, 식사보조 등의 기본간호가 제공됩니다.</p>
            <p class="bullet04 num2 depth">응급 시 호출방법 : 응급상황 또는 간호사의 도움이 필요할 때는 침상 옆에 부착되어 있는 비상벨을 눌러 간호사를 호출하시면 즉시 도움을 받으실 수 있습니다.</p>
            <p class="bullet04 num3 depth">감염관리 및 중환자실 특수 처치를 위해 중환자실 내에서 병실변경이 있을 수 있습니다.</p>
            <p class="bullet04 num4 depth"><span>각종 튜브류(카테터, 배액관, 도관 등) 및 인공호흡기, 체외순환기 등 환자의 호흡기계 및 심혈관계에 직접적으로 영향을 끼치는 의료 기구나 장비의 유지, 자해 및 타인을 해치는 것을 예방하기 위해 <span class="font-main">신체보호대를 적용할 수 있으며</span> 절차는 다음과 같습니다.</span></p>
            <p class="bullet05 depth">신체보호대 적용 필요성에 대해 환자나 보호자에게 담당의사 설명 후 적용되며 적용부위는 최소 2시간 마다 관찰됩니다.</p>
            <p class="bullet05 depth">긴급 상황에 따라서는 의료진이 우선 적용한 후 보호자에게 설명 될 수 있습니다.</p>
            <p class="bullet04 num5 depth">환자의 입원전 지참약은 담당의사 및 담당간호사에게 알려주시기 바랍니다. 입원 전 지참약은 임의로 복용할 수 없습니다.</p>
        </div>
        <div id="step2" class="step-item info">
            <h3 class="bullet01">준비물품</h3>
            <p class=" depth">환자분이 사용하실 물티슈, 기저귀, 깔개매트, 마스크 준비해 주시기 바랍니다.</p>
        </div>
        <div id="step3" class="step-item info">
            <h3 class="bullet01">회진 안내</h3>
            <p class="bullet04 num1 depth">오전 8시~10시에 회진이 있으며 진료과 사정에 따라 변동이 있을 수 있습니다.</p>
            <p class="bullet04 num2 depth">회진 시 면담을 원하시는 경우에는 담당간호사에게 말씀하여 주십시오.</p>
        </div>
        <div id="step4" class="step-item info">
            <h3 class="bullet01">식사 안내</h3>
            <p class="bullet04 num1 depth">식사가 가능한 환자분의 식사 시간은 아침 : 오전 7시~8시, 점심 : 오후 12시~1시, 저녁 : 오후 6시~7시입니다.</p>
            <p class="bullet04 num2 depth">환자가 희망하는 경우 비급여식 ‘특별식’을 선택할 수 있고, 이 경우 비용은 전액 본인 부담입니다.</p>
        </div>
        <div id="step5" class="step-item info">
            <h3 class="bullet01">면회 안내 및 주의사항</h3>
            <p class="bullet04 num1 depth">정규 면회시간</p>
            <div class="table mt20 ">
                <div class="table__inner">
                    <table>
                        <colgroup>
                            <col style="width:25%;">
                            <col style="width:25%;">
                            <col style="width:25%;">
                            <col style="width:25%;">
                        </colgroup>
                        <thead>
                            <tr>
                                <th colspan="2">구분</th>
                                <th>요일</th>
                                <th>시간</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td rowspan="2">통합 중환자실</td>
                                <td>신경계 중환자실</td>
                                <td>매일</td>
                                <td rowspan="4">13:00 ~ 13:20</td>
                            </tr>
                            <tr>
                                <td>내과계 중환자실</td>
                                <td>매일</td>
                            </tr>
                            <tr>
                                <td rowspan="2">외과 중환자실</td>
                                <td>외과계 중환자실</td>
                                <td>매일</td>
                            </tr>
                            <tr>
                                <td>심장혈관 중환자실</td>
                                <td>매일</td>
                            </tr>
                            <tr>
                                <td>대동맥혈관 중환자실</td>
                                <td>대동맥혈관 중환자실</td>
                                <td>매일</td>
                                <td>12:30 ~ 12:50</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <p class="bullet04 num2 depth mt20">면회 시 해당 중환자실 상황에 따라 면회가 제한 또는 지연될 수 있습니다.</p>
            <p class="bullet04 num3 depth">감염관리를 위해 면회객은 1인으로 제한되며 교대가 불가합니다.</p>
            <p class="bullet04 num4 depth">환자의 안정과 감염예방을 위하여 면역성이 약한 12세 이하의 아동이나 감기 및 전염성 질환이 있는 가족의 방 문을 제한하며 면회시간을 준수해주시기 바랍니다.</p>
            <p class="bullet04 num5 depth">면회 전·후에는 손소독제를 이용하거나 중환자실 입구의 세면대에서 반드시 손을 씻으시기 바랍니다.</p>
            <p class="bullet04 num6 depth">면회 시에는 중환자실 입구에 마련된 비닐가운을 착용해 주시고 중환자실 퇴실 전 비닐가운을 벗고 손을 씻은 후 퇴실해주시기 바랍니다.</p>
            <p class="bullet04 num7 depth">면회 시 낙상예방을 위해 다음의 사항을 지켜주시기 바랍니다.</p>
            <p class="bullet05 depth">침상난간은 항상 양쪽 모두 올려주시기 바랍니다.</p>
            <p class="bullet05 depth">도움이 필요하면 간호사를 부르거나 호출해 주시기 바랍니다.</p>
            <p class="bullet04 num8 depth">휴대폰은 전파장애로 인해 의료장비 오작동의 우려가 되오니 중환자실에는 반드시 꺼주시기 바랍니다.</p>
            <p class="bullet04 num9 depth">면회하는 동안 환자의 이상징후(의식변화, 흉통, 출혈, 경련, 통증 등) 발견 즉시 의료진에게 알려주시기 바랍니다.</p>
            <p class="bullet04 num10 depth">소아환자의 경우 유괴예방 및 안전을 위해 면회 시 신분확인의 절차가 진행될 수 있습니다.</p>
            <p class="bullet04 num11 depth">병문안객 관리를 위한 명부 작성 시 협조하여 주시기 바랍니다.</p>
        </div>

        <div id="step6" class="step-item info">
            <h3 class="bullet01">기타사항</h3>
            <h4 class="bullet02 type2 num1 depth">편의시설</h4>
            <p class="depth">진료비 무인수납기, 영상CD 등록기, 편의점, 은행, 카페, 푸드코트, 베이커리, 의료기기, 무인택배함 등이 있습니다.</p>

            <h4 class="bullet02 type2 num2 depth">화재 예방 및 대처방법</h4>
            <p class="depth">가족대기실에 휴대용 가스레인지, 선풍기, 전열기 사용 및 인화성, 가연성 물질의 반입을 삼가하여 주시기 바랍니다. 화재 발생 시 신속히 병원직원에게 알리고 직원의 유도에 따라 피난전실과 비상계단을 통하여 대피하시기 바랍니다.</p>

            <h4 class="bullet02 type2 num3 depth">금연</h4>
            <p class="depth">병원은 환자의 건강과 화재예방을 위하여 시설 전체가 금연구역이오니 금연에 협조하여 주시기 바랍니다.</p>

            <h4 class="bullet02 type2 num4 depth">불만 및 고충 처리</h4>
            <p class="depth">병원을 이용시 궁금했거나 불편했던 점, 칭찬하고 싶은 점이 있다면 1층 고객 상담실 방문, 전화, 병원 홈페이지를 통해 이용하실 수 있습니다.</p>

            <h4 class="bullet02 type2 num5 depth">주차 요금</h4>
            <p class="depth">중환자실 입구 게시판에 게시된 주차요금안내를 참조하시기 바랍니다.</p>

            <h4 class="bullet02 type2 num6 depth">분실 및 도난 주의</h4>
            <p class="depth">귀중품과 현금은 중환자실에 보관할 수 없습니다. 개인 보관 또는 원무과에 문의하시기 바랍니다. 의치, 보청기, 안경, 렌즈 등의 보조기는 검사 및 시술, 수술, 응급 상황 시에 제거해야 하므로 보관에 유의하시기
                바랍니다. <br>
                본인의 부주의로 인한 분실발생 시에는 의료원에서 책임지지 않습니다.</p>

            <h4 class="bullet02 type2 num7 depth">소지품 관리</h4>
            <ul class="bullet-list type2 depth">
                <li class="bullet-item">안경</li>
                <li class="bullet-item">틀니</li>
                <li class="bullet-item">보청기</li>
                <li class="bullet-item">지갑</li>
                <li class="bullet-item">핸드폰</li>
                <li class="bullet-item">옷</li>
                <li class="bullet-item">신발</li>
                <li class="bullet-item">열쇠</li>
                <li class="bullet-item">시계</li>
                <li class="bullet-item">귀걸이</li>
                <li class="bullet-item">목걸이</li>
                <li class="bullet-item">반지</li>
                <li class="bullet-item">팔찌</li>
                <li class="bullet-item">기타( <span class="gap50"></span> )를 (이름: <span class="gap100"></span>관계: <span class="gap100"></span>) 님께 전달하였습니다. </li>
            </ul>


            <h4 class="bullet02 type2 num8 depth">종교시설 안내</h4>
            <p class="depth">본원은 기독교 병원이며 주일예배는 일요일 오전 10시, 수요예배는 수요일 오후 5시, 어린이/청소년 예배는 목요일 오전 10시에 C관 3층 방주교회에서 있습니다. 병동 심방, 신앙 상담, 기타 종교 상담 등의 문의는 원목상담실 (02-6986-5724)에 전화하시면 가능하며, 원목실과 기도실은 C관 3층에 위치하고 있습니다.</p>

            <h4 class="bullet02 type2 num9 depth">퇴원절차 안내</h4>
            <p class="depth">퇴원 보험심사 후 환자 혹은 보호자에게 문자서비스가 발송됩니다. 퇴원 수납은 원무과 입퇴원 창구 또는 무인 수납기 를 이용하시고, 수납 후 퇴원 약은 간호사실에서 수령하시면 됩니다.</p>

            <h4 class="bullet02 type2 num10 depth">각종 증명서류 발급</h4>
            <p class="depth">진단서, 의무기록 및 영상 복사 등 필요한 서류는 미리 책임의사나 간호사에게 말씀하여 주시기 바랍니다.</p>

            <h4 class="bullet02 type2 num11 depth">환자의 권리와 의무</h4>
            <div class="table mt20">
                <div class="table__inner">
                    <table>
                        <colgroup>
                            <col style="width:50%;">
                            <col style="width:50%;">
                        </colgroup>
                        <thead>
                            <tr>
                                <th>환자의 권리</th>
                                <th>환자의 의무</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td class="left">
                                    <p class="bullet04 num1">진료 받을 권리</p>
                                </td>
                                <td class="left" rowspan="2">
                                    <p class="bullet04 num1">의료인에 대한 신뢰·존중 의무</p>
                                </td>
                            </tr>
                            <tr>
                                <td class="left">
                                    <p class="bullet04 num2">알 권리 및 자기결정권</p>
                                </td>
                            </tr>


                            <tr>
                                <td class="left">
                                    <p class="bullet04 num3">비밀을 보호받을 권리</p>
                                </td>
                                <td class="left" rowspan="3">
                                    <p class="bullet04 num2">부정한 방법으로 진료를 받지 않을 의무</p>
                                </td>
                            </tr>
                            <tr>
                                <td class="left">
                                    <p class="bullet04 num4">상담·조정을 신청할 권리</p>
                                </td>
                            </tr>
                            <tr>
                                <td class="left">
                                    <p class="bullet04 num5">안전한 의료환경에서 의료서비스를 제공받을 권리</p>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>

            <h4 class="bullet02 type2 num12 depth mt20">환자 또는 보호자(방문객)가 직원에게 폭력(폭언, 협박, 난동, 성폭력, 성희롱, 기물파손 등) 행위로 피해를 입힌 경우 관계법령에
                따라 처벌을 받을 수 있습니다.</h4>

            <h4 class="bullet02 type2 num13 depth mt20">환자 또는 보호자 등이 해당 의료인에 대하여 모욕죄, 명예훼손죄, 폭행죄, 업무방해죄에 해당될 수 있는 상황을 형성하여 의료인이 정상적인 의료행위를 행할 수 없도록 한 경우 의료법과 응급의료법을 위반하지 않는 범위 내 에서 진료를 거부(진료거부권)할
                수 있습니다.</h4>

            <h4 class="bullet02 type2 num14 depth mt20">입원기간 동안 CCTV를 통해 환자의 상태를 관찰하며 녹화는 되지 않습니다</h4>

        </div>

        <div id="step7" class="step-item info">
            <h3 class="bullet01">중환자실 입원 시 필요물품 리스트</h3>

            <h4 class="bullet02 depth">중환자실 내 면회 안내</h4>
            <p class="depth">중환자실 내 정규 면회시간 : 매일 <span class="font-main">({{ visitingTime }})</span> 입니다.</p>

            <h4 class="bullet02 depth">중환자실에서 일반병동 전동시 안내</h4>
            <p class="depth"><span class="font-main">중환자실</span>에서 일반병동 전동시 24시간 간병을 할 수 있는 간병인 또는 보호자가 필요합니다. 거동가능한 환자는 앞뒤가 막힌 실내화를 준비해주세요.</p>

            <h4 class="bullet02 depth">기타 안내</h4>
            <p class="depth">초응급 환자 발생시 진료과 판단에 따라 시간에 상관없이 응급으로 병실로 전동 될 수 있으니 양해부탁드립니다.</p>

            <h4 class="bullet02 depth">중환자실 필요물품</h4>
            <div class="need-item">
                <div class="need-item__text">
                    <p class="bullet04 num1 depth">입원전 복용약 (본원약 제외)</p>
                    <p class="bullet04 num2 depth">기저귀(날개형O, 팬티형X)</p>
                    <p class="bullet04 num3 depth">깔개매트, 물티슈(대형)</p>
                    <p class="bullet04 num4 depth">입술에 바르는 바세린</p>
                    <p class="bullet04 num5 depth">종이컵, 생수 500ml*2 (필요시)</p>
                    <p class="bullet04 num6 depth">의식이 있는 경우:칫솔, 치약, 빨대형 물컵, 곽티슈</p>


                    <!-- <p class="bullet04 num7 depth"><span><span class="font-main">수술 후 환자의 경우</span>(필요시):트리플로우(호흡기치료기)*1</span></p>
                    <p class="bullet05 depth">지하1층 의료기상사에서 구입가능</p> -->
                </div>
                <div class="need-item__img">
                    <img src="@/assets/resource/img/needitem.png" alt="">
                </div>
            </div>

            <h4 class="bullet02 depth">중환자실 내 귀중품 보관 불가 안내</h4>
            <p class="depth">중환자실 내에서는 개인용 휴대폰 사용이 불가합니다. 귀중품 분실시 책임지지 않으니 모두 가지고 돌아가주시기 바랍니다. 틀니/보청기 착용시 알려주세요.</p>

            <h4 class="bullet02 depth">물품 구매 가능 장소</h4>
            <p class="bullet03 depth">24시 : <span class="font-main">지하 1층 CU 편의점</span></p>
            <p class="bullet03 depth">월~금 9am~6pm :<span class="font-main">지하 1층 의료기상사</span></p>
        </div>

    </div>
</template>
<script>
    // Import Swiper Vue.js components
    import { Swiper, SwiperSlide } from 'swiper/vue';

    // Import Swiper styles
    import 'swiper/css';

    import 'swiper/css/navigation';
    import 'swiper/css/pagination';

    import { Navigation, Pagination, Mousewheel, Keyboard } from 'swiper/modules';

    export default {
        components: {
            Swiper,
            SwiperSlide,
        },
        setup() {
            return {
                modules: [Navigation, Pagination, Mousewheel, Keyboard],
            };
        },
        data() {
            return {
                lnbIndex: 1,
            };
        },
        mounted() {
            window.addEventListener('scroll', this.handleScroll);
        },
        methods: {
            scrollTo(id) {
                const element = document.getElementById(id);
                if (element) {
                    // 해당 요소의 위치와 크기 정보 가져오기
                    const elementTop = element.getBoundingClientRect().top + window.pageYOffset;

                    // 스크롤을 이동할 위치를 계산 (100px 추가)
                    const scrollToPosition = elementTop - 100;

                    // 계산된 위치로 부드럽게 스크롤
                    window.scrollTo({
                    top: scrollToPosition,
                    behavior: 'smooth'
                    });
                }
            },
            handleScroll() {
                const sections = document.querySelectorAll('.step-item');
                sections.forEach((section, index) => {
                    const rect = section.getBoundingClientRect();
                    // Check if the top of the section is within the viewport
                    if (rect.top <= 101 && rect.top <= window.innerHeight) {
                        this.lnbIndex = index + 1; // Update lnbIndex based on the section's position
                    }
                });
            },
            lnbFn(index) {
                this.lnbIndex = index; // Change the active index when clicking the menu
            },
        },
        computed: {
            visitingTime() {
            if (this.$store.getters.getHost === 'H0007') {
                return '13:00 ~ 13:20';
            }
            // 기본값
            return '12:30 ~ 12:50';
            }
        }
    };
</script>